<template>
  <div>
    <Loader :isLoading="getLoadingResults" />
    <div>
      <Header
        v-if="
          !this.$store.getters.iframeColidee
        "
        :window="window"
        :parameters="'adminResultats'"
      />
      <div
        :class="
          !this.$store.getters.iframeColidee
            ? window.width < 480
              ? 'container-fluid'
              : 'container'
            : ''
        "
      >
        <Bandeau
          v-if="
            !this.$store.getters.iframeColidee
          "
          :window="window"
          :background="background"
          :sondageName="sondageName"
        />
        <ButtonReturnColidee
          style="margin-left:5px"
          v-if="
            this.$store.getters.iframeColidee
          "
        />
        <ContentResultats
          :style="
            this.$store.getters.iframeColidee
              ? 'padding:5px;'
              : ''
          "
          :window="window"
          :sondageName="sondageName"
        />
      </div>
      <br /><br />
      <b-modal
        :width="640"
        :active="modalExportExcelPdf.activeModalExportExcelPdf"
      >
        <ModalExportExcelPdf :modalExportExcelPdf="modalExportExcelPdf"
      /></b-modal>
      <MyFooter
        v-if="
          !this.$store.getters.iframeColidee
        "
        :window="window"
      />
    </div>
  </div>
</template>

<script>
import MyFooter from '@/components/layout/MyFooter'
import Loader from '@/components/layout/Loader'
import Header from '@/components/layout/Header'
import ContentResultats from '@/components/resultats/ContentResultats'
import Bandeau from '@/components/resultats/components/Bandeau'
import { mapGetters } from 'vuex'
import axios from 'axios'
import ModalExportExcelPdf from '@/components/sondage/components/ModalExportExcelPdf'
import ButtonReturnColidee from '@/components/button/ButtonReturnColidee'

export default {
  name: 'Resultats',
  components: {
    Header,
    Loader,
    MyFooter,
    ContentResultats,
    Bandeau,
    ButtonReturnColidee,
    ModalExportExcelPdf
  },
  data () {
    return {
      sondageName: '',
      url_moderateur: this.$route.params.url_moderateur,
      idSondage: null,
      background: '',
      window: {
        width: window.innerWidth
      },
      urlSondage: process.env.URL_MEDIA
    }
  },
  beforeDestroy () {
    this.$store.commit('UNLOAD_RESULTATS')
  },
  mounted () {
    this.sendMessageToParent('scrollToTop')
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    handleResize () {
      this.window.width = window.innerWidth
    }
  },
  created () {
    this.$store.commit('SET_LOADING_RESULTS', true)
    axios.defaults.headers.common['urlmoderateur'] = this.url_moderateur
    axios
      .get(process.env.URL_SSO_API + 'sondage/checkurlmoderateur')
      .then(response => {
        this.idSondage = response.data[0][0].id
        // Connexion à la room temps réel
        var room = 'Room_Sondage_' + this.idSondage
        this.$socket.emit('room', room)
        this.$store.commit(
          'CONFIGURE_QUESTIONS_SONDAGE_NAME',
          response.data[0][0].name
        )
        this.$store.commit('ADMIN_SONDAGE_ID', response.data[0][0].id)
        this.$store.commit(
          'ADMIN_SONDAGE_URL_MODERATEUR',
          response.data[0][0].url_moderateur
        )
        this.sondageName = response.data[0][0].name
        if (response.data[0][0].media) {
          this.background =
            "background-size:cover;background-image:url('" +
            this.urlSondage +
            response.data[0][0].media +
            "')"
        } else {
          this.background =
            'background-size: cover;background-image:url(' +
            require('@/assets/img/bandeau/bandeau.jpg') +
            ')'
        }
        if (response.data[1].length) {
          this.$store.commit('UPDATE_TYPE_FORM', 'simple')
          this.$store.commit('LOAD_QUESTIONS', response.data[1])
          if (response.data[1][0].onglet === 'Section') {
            this.$store.commit('UPDATE_TYPE_FORM', 'section')
          }
        }
        this.$store.dispatch(
          'getSondage',
          this.$store.state.sondage.configure_questions_sondage
        )
        this.$store.dispatch('getResultats', {
          urlmoderateur: this.url_moderateur,
          idSondage: this.idSondage
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    ...mapGetters([
      'sondage_id',
      'configure_questions_sondage',
      'getLoadingResults',
      'isLoading',
      'modalExportExcelPdf'
    ]),
    reversedMessage: function () {
      return this.message
        .split('')
        .reverse()
        .join('')
    }
  },

  sockets: {
    connect () {
      if (this.idSondage !== -1) {
        this.$store.commit('SET_LOADING_RESULTS', true)
        var room = 'Room_Sondage_' + this.idSondage
        this.$socket.emit('room', room)
        this.$store.dispatch('getResultats', {
          urlmoderateur: this.url_moderateur,
          idSondage: this.sondage_id
        })
        // console.log("re-connect"), room;
      }
    },
    disconnect () {
      // console.log("disconnect");
    },

    channel (data) {
      data = JSON.parse(decodeURIComponent(data))
      if (data.type === 'NEW_REPONSE') {
        this.$store.dispatch('getResultats', {
          urlmoderateur: this.url_moderateur,
          idSondage: this.idSondage
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/Resultats.vue